import { Button, Image, IModalWindowProps, ModalWindow, UIHeading1, UIHeading2, useDeviceType } from '@cian/ui-kit';
import { IImageSource } from '@cian/ui-kit/image/types';
import * as React from 'react';
import cn from 'classnames';
import { ReadMoreLink } from '../ReadMoreLink';
import * as styles from './styles.css';

const desktopImageSrcSets: IImageSource[] = [
  {
    srcset: 'https://cdn.cian.site/frontend/e2e-form-assets/promo/services/new_passport_and_nfc_1x.png',
  },
  {
    srcset: 'https://cdn.cian.site/frontend/e2e-form-assets/promo/services/new_passport_and_nfc_2x.png',
    media: '(-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi)',
  },
];

const mobileImageSrcSets: IImageSource[] = [
  {
    srcset: 'https://cdn.cian.site/frontend/e2e-form-assets/promo/services/new_passport_and_nfc_white_bg_1x.png',
  },
  {
    srcset: 'https://cdn.cian.site/frontend/e2e-form-assets/promo/services/new_passport_and_nfc_white_bg_2x.png',
    media: '(-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi)',
  },
];

const MOBILE_IMG_SRC =
  'https://cdn.cian.site/frontend/e2e-form-assets/promo/services/new_passport_and_nfc_white_bg_1x.png';
const DESKTOP_IMG_SRC = 'https://cdn.cian.site/frontend/e2e-form-assets/promo/services/new_passport_and_nfc_1x.png';

export const E2eDealDescriptionModal: React.FC<Partial<IModalWindowProps>> = props => {
  const isMobile = useDeviceType() === 'phone';
  const Heading = isMobile ? UIHeading2 : UIHeading1;

  return (
    <ModalWindow {...props} width={928}>
      <div className={cn(styles['container'], isMobile && styles['container-mobile'])}>
        <Image
          height="auto"
          src={isMobile ? MOBILE_IMG_SRC : DESKTOP_IMG_SRC}
          sources={isMobile ? mobileImageSrcSets : desktopImageSrcSets}
        />
        <div className={cn(styles['heading'], isMobile && styles['heading-mobile'])}>
          <Heading>Что такое онлайн-сделка</Heading>
        </div>
        <div className={cn(styles['description'], isMobile && styles['description-mobile'])}>
          Онлайн-сделка — это сервис, который делает за вас всю работу по оформлению и регистрации сделки:
          <ul className={styles['features-list']}>
            <li>организует полное сопровождение сделки;</li>
            <li>помогает подписать документы электронными подписями в специальном приложении;</li>
            <li>отправляет документы в Росреестр и оплачивает госпошлину; </li>
            <li>организует безопасные взаиморасчёты, если нужно.</li>
          </ul>
        </div>
        <div className={cn(styles['actions'], isMobile && styles['actions-mobile'])}>
          <Button fullWidth={isMobile} onClick={props.onClose}>
            Понятно
          </Button>
          <ReadMoreLink theme="not-filled" />
        </div>
      </div>
    </ModalWindow>
  );
};
